import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import AddToCartButton from '../customize-product/AddToCartButton';
import { Box } from '../../../ui-library/layout';
import { Cabbage, Earth, Venus } from '../../../ui-library/typography';
import { clone } from '../../../utils/object';
import { CATEGORY_FABRICS } from '../../../utils/constants';
import FabricMeters from './FabricMeters';
import ProductPrice from '../../../ui-library/ProductPrice';
import { Space } from '../../../ui-library/space';
import useAddToCart from '../customize-product/useAddToCart';
import useNavigation from '../../../utils/useNavigation';

function FabricSummary({ product }) {
  const [meters, setMeters] = useState(1);
  const { addToCart } = useAddToCart();
  const { goToCart } = useNavigation();
  const handleClick = () => {
    const obj = clone(product);
    obj.type = CATEGORY_FABRICS;
    obj.meters = meters;
    addToCart(obj);
    goToCart();
  };
  return (
    <div>
      <Row>
        <Box justifyContent='space-between' className='full-width'>
          <Cabbage as='h1'>{product.name}</Cabbage>
        </Box>
      </Row>
      <Row>
        <Earth>{product.description}</Earth>
      </Row>
      <Space size={2} />

      <Row>
        <Col className='p-0'>
          <Venus marginTop='12px'>Bunch Name:</Venus>
          {product.bunchName}
          <Venus marginTop='12px'>Swatch code:</Venus>
          {product.swatchCode}
          <Venus marginTop='12px'>Width:</Venus>
          {product.width}
          <Venus marginTop='12px'>Composition:</Venus>
          {product.composition}
          <Venus marginTop='12px'>Weight:</Venus>
          {product.weight}
          <Venus marginTop='12px'>Color:</Venus>
          {product.color}
          <Venus marginTop='12px'>Weave:</Venus>
          {product.weave}
          <Venus marginTop='12px'>Season:</Venus>
          {product.season}
          <Venus marginTop='12px'>Use:</Venus>
          {product.useCase}

          <Space size={8} />
          <Venus marginTop='12px'>Price/meter:</Venus>
          <Space size={2} />
          <ProductPrice price={product.price} />
          <Space size={8} />
          <FabricMeters
            meters={meters}
            setMeters={setMeters}
            isEditable={true}
            title='Required Meters : '
          />
          <Space size={4} />
          <AddToCartButton onClick={handleClick} />
        </Col>
      </Row>
    </div>
  );
}

export default FabricSummary;
